// eslint-disable-next-line no-unused-vars
import React from 'react';
import { createPortal } from 'react-dom';

import FooterComponent from 'Components/Footer/Footer';

const Footer = () => {
  if (typeof document !== 'undefined') {
    const footerEl = document.getElementById('root-footer');
    return createPortal(<FooterComponent />, footerEl);
  }

  return <FooterComponent />;
};

export default Footer;
